import CheckBox from "components/general/CheckBox";
import useToggleState from "hooks/useToggleState";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { parseParam, stringifyParam } from "utils/queryParamService";
import styles from "./styles.module.scss";
import ModalWrapper from "../ModalWrapper";
import { FilterSelectionModalProps } from "./types";

export default function FilterSelectionModal({
  data,
  filterType,
  isVisible = false,
  setIsVisible,
}: FilterSelectionModalProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    selectedValues: selectedFilterValues,
    addToSelected: addToFilter,
    replaceState: replaceFilterWith,
    isSelected: isAlreadyInFilter,
  } = useToggleState<string>([]);

  const onChangeValueHandler = (value: string) => {
    addToFilter(value);
  };

  useEffect(() => {
    if (isVisible) {
      const defaultFilterValues = searchParams.get(filterType);
      if (defaultFilterValues) {
        const parsedDefaultFilterValues = parseParam(defaultFilterValues);
        replaceFilterWith(parsedDefaultFilterValues);
      }
    } else {
      replaceFilterWith([]);
    }
  }, [isVisible, filterType]);

  const onConfirmHandler = () => {
    // A copy, so the URL is the only place the change lands and the params the
    // page is currently rendering from are left alone.
    const nextParams = new URLSearchParams(searchParams);
    const nextValue = stringifyParam(selectedFilterValues);

    nextParams.set("page", "1");
    // Clearing every option means the filter is off, so its key leaves the URL
    // rather than lingering as `type=`, which still reads as a filter in play.
    if (nextValue) nextParams.set(filterType, nextValue);
    else nextParams.delete(filterType);

    setSearchParams(nextParams);

    setIsVisible(false);
  };

  const paramsList = searchParams.get(filterType)?.split(",");

  return (
    <ModalWrapper
      setIsVisible={setIsVisible}
      size="small"
      headerTitle={`Filter by ${filterType}`}
      headerTitleJustify="start"
      isVisible={isVisible}
      onConfirm={onConfirmHandler}
    >
      <div style={{ width: "100%" }} className="p-3">
        {data?.map((item) => (
          <div
            className={styles.container}
            style={{
              backgroundColor: !isAlreadyInFilter(item.value)
                ? "#D9D9D91A"
                : "#e3332d0d",
            }}
          >
            <CheckBox
              text={item.label}
              defaultChecked={paramsList?.includes(item.value)}
              onValueChange={() => {
                onChangeValueHandler(item.value);
              }}
            />
          </div>
        ))}
      </div>
    </ModalWrapper>
  );
}
